import { render, staticRenderFns } from "./AjusteAnual.vue?vue&type=template&id=32604a02&scoped=true"
import script from "./AjusteAnual.vue?vue&type=script&lang=js"
export * from "./AjusteAnual.vue?vue&type=script&lang=js"
import style0 from "./AjusteAnual.vue?vue&type=style&index=0&id=32604a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32604a02",
  null
  
)

export default component.exports